import React, { Component } from "react";
import share from "../../assets/share.png";
import defaultImage from "../../assets/default.jpg";

export default ({ listInfoGraphic, baseURL }) => {
  return (
    <section class="akun-saya">
      <div className="container">
        <div className="row" style={{ flexWrap: "nowrap", overflowX: "auto" }}>
          {listInfoGraphic.length ? (
            listInfoGraphic.map((e) => (
              <div
                className="col-lg-3 col-md-3 col-sm-10 col-10"
                onClick={() => window.open(baseURL + e.url)}
                style={{ cursor: 'pointer'}}
              >
                <img
                  className="mb-4"
                  src={e.thumbnail ? baseURL + "/" + e.thumbnail : defaultImage}
                  alt="grey"
                  style={{ width: "100%", height: "150px", objectFit: "cover" }}
                />
                <p style={{ fontSize: "16px", fontWeight: "600" }}>{e.title}</p>
                <div style={{ fontSize: "12px", marginBottom: "25px" }}>
                  <p className="text-muted mb-1">Kategori Infografik</p>
                  <p className="text-muted mb-1">{e.source}</p>
                </div>
                {/* <div className="d-flex">
                  <a
                    className="btn btn-blue"
                    href={e.url}
                    target="_blank"
                    style={{ fontSize: "13px", padding: "9px 30px !important" }}
                  >
                    Download
                  </a>
                  <a href="">
                    <img
                      className="ml-4"
                      src={share}
                      alt="share"
                      style={{
                        width: "23px",
                        height: "23px",
                        marginTop: "7px",
                      }}
                    />
                  </a>
                </div> */}
              </div>
            ))
          ) : (
            <div>No Data Founded</div>
          )}
        </div>
      </div>
    </section>
  );
};
